const productsSlider = {
    _sliderObject: null,
    init() {  
        if(document.querySelectorAll('.js-products-slider').length === 0) {
            return;
        }
        let self = this;
        const scriptUrl = 'https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.js';
        const cssUrl = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
        window.initPackages([cssUrl, scriptUrl]).then(() => {
            self._constructSlider();
        }).catch((error) => {
            console.error(error);
        });
    },
    _constructSlider() {
        let self = this;
        self._sliderObject = new Swiper('.js-products-slider', {
            slidesPerView: 2,
            spaceBetween: 8,
            loop: false,
            effect: 'slide',
            autoplay: true,
            rewind: true,
            breakpoints: {
                // when window width is >= 320px
                
                576: {
                  slidesPerView: 2,
                  spaceBetween: 24
                },
                // when window width is >= 640px
                768: {
                  slidesPerView: 3,
                  spaceBetween: 24
                },
                992: {
                    slidesPerView: 4,
                    spaceBetween: 24
                  }
            },
           
            navigation: {
                nextEl: '.js-products-slider__next-btn',
                prevEl: '.js-products-slider__prev-btn',
            },

            pagination: {
                el: '.js-products-slider__pagination',
                clickable: true
              },
        })
        
    },
    reInit() {
        let self = this;
        if(self._sliderObject) {
            self._sliderObject.destroy();
            self._sliderObject = null;
        }
        self.init();
    },
}
productsSlider.init();
document.addEventListener('LokiRequestEnd', function () { 
    productsSlider.reInit();
});


